<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/trans#abb"><em>Translations and Abbreviations</em></a></p>
<p class="toc"><a href="#/xhtml/acknow#ack"><em>Acknowledgments</em></a></p>
<p class="toc"><a href="#/xhtml/intro#int">Introduction</a></p>
<p class="toca"><a href="#/xhtml/chapter01#ch1">1. The “Living Script”: <em>Jerusalem</em>’s Perplexing Arguments</a></p>
<p class="toca"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2. Conceptual Disfiguring: Jewish Practice and Philosophical History</span></p>
<p class="toca"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3. The Felicity of the Nation: Jewish Practice and Social History</span></p>
<p class="toca"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4. “The Strict Obedience We Owe”: Jewish Practice and the Study of History</span></p>
<p class="toca"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5. Rethinking Mendelssohn: Mendelssohn’s Historical Judaism</span></p>
<p class="toc"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion: Beyond Mendelssohn: History, Modernity, and Religious Practice</span></p>
<p class="toct"><span href="#/xhtml/notes#not" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?518b3b91